import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-[#0B1F3A] text-[#F8F7F2] mt-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo variant="light" />
          <p className="mt-6 max-w-md text-sm leading-relaxed text-[#F8F7F2]/70">
            Connecting global capital with strategic opportunities across energy, infrastructure,
            technology, and real assets — with disciplined risk management and long-term value creation
            at the core.
          </p>
        </div>
        <div className="md:col-span-2">
          <div className="eyebrow" style={{ color: "#D4AF37" }}>Firm</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/about" className="text-[#F8F7F2]/80 hover:text-[#D4AF37]">About</Link></li>
            <li><Link to="/strategies" className="text-[#F8F7F2]/80 hover:text-[#D4AF37]">Strategies</Link></li>
            <li><Link to="/initiatives" className="text-[#F8F7F2]/80 hover:text-[#D4AF37]">Strategic Initiatives</Link></li>
            <li><Link to="/portfolio" className="text-[#F8F7F2]/80 hover:text-[#D4AF37]">Portfolio</Link></li>
            <li><Link to="/insights" className="text-[#F8F7F2]/80 hover:text-[#D4AF37]">Insights</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="eyebrow" style={{ color: "#D4AF37" }}>Access</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/portal" className="text-[#F8F7F2]/80 hover:text-[#D4AF37]">Investor Portal</Link></li>
            <li><Link to="/contact" className="text-[#F8F7F2]/80 hover:text-[#D4AF37]">Contact</Link></li>
            <li><Link to="/login" className="text-[#F8F7F2]/80 hover:text-[#D4AF37]">Sign In</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="eyebrow" style={{ color: "#D4AF37" }}>Offices</div>
          <ul className="mt-4 space-y-3 text-sm text-[#F8F7F2]/80">
            <li>
              <div className="font-semibold text-[#F8F7F2]">Providence, RI</div>
              <div>United States Headquarters</div>
            </li>
            <li>
              <div className="font-semibold text-[#F8F7F2]">Beijing</div>
              <div>Asia Operations</div>
            </li>
            <li>
              <div className="font-semibold text-[#F8F7F2]">Africa</div>
              <div>Lagos · Addis Ababa</div>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[#F8F7F2]/50">
          <div>© {new Date().getFullYear()} First Providence Capital. All rights reserved.</div>
          <div className="flex gap-6">
            <span>Confidential — Institutional Use</span>
            <span>Not an offer to sell securities</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
